import { useCallback, useEffect, useRef } from 'react'
import { prefetchVideoHead } from '@/lib/videoPrefetch'

// マウスが通り過ぎただけで先読みしないよう、ホバー意図を待つディレイ
const HOVER_PREFETCH_DELAY_MS = 200

/**
 * サムネのホバー意図（一定時間ホバー）に応じて、動画の出だしを先読みするためのハンドラを返す。
 * 各カードの onPointerEnter / onPointerLeave に割り当てて使う。
 */
export const useHoverPrefetch = () => {
  const timerRef = useRef<ReturnType<typeof setTimeout>>(undefined)

  const schedulePrefetch = useCallback((videoUrl: string | null | undefined) => {
    clearTimeout(timerRef.current)
    timerRef.current = setTimeout(() => prefetchVideoHead(videoUrl), HOVER_PREFETCH_DELAY_MS)
  }, [])

  const cancelPrefetch = useCallback(() => {
    clearTimeout(timerRef.current)
  }, [])

  // アンマウント時に保留中のタイマーを後始末
  useEffect(() => () => clearTimeout(timerRef.current), [])

  return { schedulePrefetch, cancelPrefetch }
}
